const es = {
    navbar: {
        home: "Inicio",
        skills: "Habilidades",
        projects: "Proyectos",
        contact: "Contactame",
    },

    home: {
        code1: `0  // Documentación Kdoc                                          
1   
2  // Función principal del programa
3  
4  // Altamente motivado para trabajar, crecer profesionalmente
5  // y aprender cosas nuevas. Me adapto bien y
6  // rápidamente a nuevos frameworks y lenguajes.
7  // 
8  // Los lenguajes que más he utilizado son Kotlin y C#,
9  // también Java, Python y Dart pero de forma más
10 // superficial.
11 // 
12 // También disfruto del desarrollo de videojuegos pero
13 // por ahora solo lo he hecho
14 // de forma individual.
15`,
        code2: `17
18 // @param args Lo necesario para que funcione al despertar
19 fun main(args) {
20    WakeUp(args)
21 }`,
        copied: "¡Copiado!"
    },
    skills: {
        skillsTitle:"<Habilidades/>",
        languajes: "Lenguages",
        frameworks: "Librerias",
        databases:"Base de datos",
        tools:"Herramientas",
        IDES:"IDES",
        versionContol:"Control de versiones"
    },
    projects: {
        projectsTitle:"<Proyectos/>",
        casino404: `
            Un proyecto full-stack que recrea un póker multijugador.<br><br>
            El backend está desarrollado con <strong>Spring Boot</strong> y <strong>WebSockets</strong>, 
            y el cliente con <strong>Compose Multiplatform</strong>.<br><br>
            Incluye comunicación en tiempo real, autenticación, gestión de mesas y lógica de juego.<br>
            <a href="https://github.com/ftrugon/CASINO-404.git" target="_blank">Ver repositorio del servidor</a> <br>
            <a href="https://github.com/ftrugon/TFG-Cliente.git" target="_blank">Ver repositorio del cliente</a>
            `,
        tltb: `
            Un pequeño juego en Unity donde el objetivo es derrotar a un jefe.<br><br>
            Aprendí los fundamentos de vectores, colisiones, comportamiento de enemigos y movimiento.<br>
            <a href="https://github.com/ftrugon/To-learn-the-basics.git" target="_blank">Ver repositorio</a>
            `,
        complexfps: `
            Un shooter en primera persona más avanzado, enfocado en las mecánicas de movimiento, 
            sistemas de disparo, IA de enemigos y lógica de armas.<br><br>
            <a href="https://github.com/ftrugon/Complex-FPS.git" target="_blank">Ver repositorio</a>
            `,
        pooKnight: `
            Un pequeño plataformas 2D donde experimenté con hitboxes, animación y diseño de niveles.<br><br>
            También se conecta a una API para mostrar el mejor tiempo en el marcador.<br>
            <a href="https://github.com/ftrugon/Poo-Knight.git" target="_blank">Ver repositorio del juego</a> <br>
            <a href="https://github.com/ftrugon/PSP_API.git" target="_blank">Ver repositorio de la API</a>
            `
        },
    contactme: {
        contacTitle: "<Contactame/>",
        alert1:"Enviado correctamente!",
        alert2:"Hubo un error al enviar el mensaje.",
        name:"Tu nombre",
        mail:"Tu mail",
        msg:"Tu mensaje",
        send:"Enviar!"
    }

};

export default es;
